module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "flex center-flex-y",
    on: {
      "click": _vm.showModalEditBrand
    }
  }, [_vm._v("EDIT ARTICLE")]), _vm._v(" "), (_vm.showBrandEditModal) ? _c('modal-brandedit', {
    attrs: {
      "modal": _vm.showBrandEditModal,
      "passedObject": _vm.objectToPass
    },
    on: {
      "update:modal": function($event) {
        _vm.showBrandEditModal = $event
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-261ac445"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/branded/ModalEditbrand.vue
// module id = 634
// module chunks = 1